import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

type LoadingSpinnerProps = {
  message?: string;
};

function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <Grid
      container
      direction="column"
      data-testid="page-loading-spinner"
      alignContent="center"
      alignItems="center"
      gap="16px"
    >
      <CircularProgress sx={theme => ({ color: theme.palette.soy.light })} />
      {!!message && (
        <Typography
          component="p"
          sx={theme => ({ color: theme.palette.soy.dark, fontWeight: 500 })}
        >
          {message}
        </Typography>
      )}
    </Grid>
  );
}

export default LoadingSpinner;
